import { GetReaderReportRequest } from '../requestModels/getReaderReportRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { httpGet, httpGetFile } from './api.service';
import { ReaderReport } from '../types/ReaderReport';

const getReaderReportByImei = async (request: GetReaderReportRequest): Promise<PaginatedResult<ReaderReport>> => {
  return await httpGet<PaginatedResult<ReaderReport>>(`api/readerreport/`, request);
};

const exportReaderReportByImei = async (request: GetReaderReportRequest): Promise<void> => {
  return await httpGetFile(`api/readerreport/export`, request);
};

const getReaderReportById = async (request: GetReaderReportRequest): Promise<PaginatedResult<ReaderReport>> => {
  return await httpGet<PaginatedResult<ReaderReport>>(`api/readerreport/`, request);
};

export { getReaderReportByImei, exportReaderReportByImei, getReaderReportById };
